var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import isArray from 'lodash/isArray';
import isPlainObject from 'lodash/isPlainObject';

export function normalizePath(originalPath) {
  var path = String(originalPath);
  return path.replace(/\[/g, '.').replace(/\]/g, '');
}

export function dirty(value) {
  if (isArray(value)) {
    return [].concat(value);
  }

  if (isPlainObject(value)) {
    return _extends({}, value);
  }

  return value;
}

export default function markAsDirty(value, originalPath, updateCallback) {
  var start = dirty(value);
  var path = normalizePath(originalPath);
  var parts = path.split('.');

  var current = start;
  var before = void 0;

  parts.forEach(function (key) {
    current[key] = dirty(current[key]);

    before = current;
    current = current[key];
  });

  if (updateCallback) {
    var newValue = updateCallback(current);

    if (before !== undefined && parts.length) {
      var lastKey = parts[parts.length - 1];
      before[lastKey] = newValue;
    }
  }

  return start;
}
//# sourceMappingURL=markAsDirty.js.map